import { useTranslation } from 'react-i18next';

/**
 * How many, with big tap targets.
 *
 * A bare number box is easy to miss on a phone and hard to change while
 * talking to a customer. Minus and plus sit on either side of the number.
 */
export function QuantityStepper({
  label,
  value,
  min,
  max,
  disabled,
  onChange,
}: {
  label: string;
  value: number;
  min: number;
  max: number;
  disabled?: boolean;
  onChange: (value: number) => void;
}) {
  const { t } = useTranslation();
  const current = Math.min(max, Math.max(min, Math.trunc(value) || min));

  return (
    <div className="min-w-0 max-w-full">
      <span className="field-label">{label}</span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          className="inline-flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-md border border-[color:var(--color-line)] text-lg font-semibold disabled:opacity-40"
          aria-label={t('quoteWork.decrease', { label })}
          disabled={disabled || current <= min}
          onClick={() => onChange(current - 1)}
        >
          −
        </button>
        <input
          className="field-control min-w-[calc(4ch+28px)] w-16 px-[12px] text-center tabular"
          inputMode="numeric"
          aria-label={label}
          disabled={disabled}
          value={String(current)}
          onChange={(event) => {
            const parsed = Number(event.target.value);
            if (!Number.isFinite(parsed)) return;
            onChange(Math.min(max, Math.max(min, Math.trunc(parsed))));
          }}
        />
        <button
          type="button"
          className="inline-flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-md border border-[color:var(--color-line)] text-lg font-semibold disabled:opacity-40"
          aria-label={t('quoteWork.increase', { label })}
          disabled={disabled || current >= max}
          onClick={() => onChange(current + 1)}
        >
          +
        </button>
      </div>
    </div>
  );
}
